import { ConstraintPrematureWellShutdownBase } from './base/constraint-premature-well-shutdown-base';

export class ConstraintPrematureWellShutdown extends ConstraintPrematureWellShutdownBase { }